import { ControlledTextField } from '../../../../shared/components';

export default function AlliedWorkSection({ label = 'Specify', orientation = 'row' }) {
  return (
    <>
      <ControlledTextField
        id='alliedWorkDetails'
        name='details.alliedWorkDetails'
        label={label}
        placeholder='Enter allied work details'
        rules={{ required: 'Allied work details are required' }}
        isMultiline
        rows={3}
        orientation={orientation}
        sx={{ flex: 1 }}
        showErrorInline
      />
    </>
  );
}
